import { Breakpoint } from '@mui/material'

export const DRAWER_WIDTH = 240

export const PERMANENT_DRAWER_BREAKPOINT: Breakpoint = 'md'
